import {Component, OnInit, ViewChild} from '@angular/core';
import {SettingsService, GeneralSetting, GeneralSettingsOutput} from '../settings.service';
import {DropdownValues, DropdownSelectionMode, DropdownValue} from 'src/app/widgets/dropdown/dropdown.component';
import {DxTreeListComponent} from 'devextreme-angular';
import {Title} from '@angular/platform-browser';
import {LocalStorageService} from 'src/app/services/local-storage.service';
import {AuthService} from 'src/app/services/auth.service';
import { LocalizationService } from 'src/app/services/localization.service';

@Component({
    selector: 'app-general-settings',
    templateUrl: './general-settings.component.html',
    styleUrls: ['./general-settings.component.scss'],
    standalone: false
})
export class GeneralSettingsComponent implements OnInit {
	settings: SettingTreeElement[] = [];
	listsDropdown: DropdownValues = new DropdownValues();


	@ViewChild('treeList')
	treeList: DxTreeListComponent;

	constructor(
		private settingsService: SettingsService,
		private authService: AuthService,
		private titleService: Title,
		private localStorageService: LocalStorageService,
		private localizationService: LocalizationService
	) {}

	ngOnInit() {
		this.init();
		this.titleService.setTitle('General Settings');
	}

	init() {

		let $this = this;

		this.settingsService.GetGeneralSettingsNew().subscribe((result) => {
			$this.settings = this.mapSettingsToTreeElements(result.settings);

			$this.settings.forEach((element) => {
				element.listValues = result.lists.filter((x) => x.listId === element.listId);
			});

			$this.listsDropdown = new DropdownValues();
			$this.listsDropdown.selectionMode = DropdownSelectionMode.single;
			$this.listsDropdown.showClearButton = false;
			$this.listsDropdown.displayName = '';
			$this.listsDropdown.values = result.lists.map((list) => new DropdownValue(list.listId, list.listElement));
		});
	}

	private mapSettingsToTreeElements(settings: GeneralSetting[]): SettingTreeElement[] {
		let treeElements: SettingTreeElement[] = [];
		let maxElement = settings.length;

		settings.forEach((setting, index) => {
			if (setting.parentSettingGroupId && treeElements.filter((element) => element.groupId === setting.parentSettingGroupId).length === 0) {
				treeElements.push(new SettingTreeElement(setting.parentSettingGroupId, null, null, null, setting.parentSettingGroupName, null, setting.parentSettingGroupDescription, true));
			}

			if (treeElements.filter((element) => element.groupId === setting.settingGroupId).length === 0) {
				treeElements.push(new SettingTreeElement(setting.settingGroupId, setting.parentSettingGroupId, null, null, setting.settingGroupName, null, setting.settingGroupDescription, true));
			}

			treeElements.push(new SettingTreeElement(maxElement + index, setting.settingGroupId, setting.id, setting.listId, setting.name, setting.value, setting.description, false));
		});

		return treeElements;
	}

	settingPropertyChanged(propertyName: string, setting: SettingTreeElement, value: any) {
		setting[propertyName] = value;
	}

	save() {

		this.localizationService.setCurrentLocalizationLanguage();
		let settingsToSave = this.settings.filter((setting) => !setting.isGroup).map((setting) => new GeneralSettingsOutput(setting.settingId, setting.listId, setting.value, setting.description));
		this.settingsService.saveGeneralSettings(settingsToSave).subscribe(() => {
			this.treeList.expandedRowKeys = [];

			this.localStorageService.set('applicationColor', null);
			this.localStorageService.set('applicationVersion', null);
			this.localStorageService.set('applicationTitle', null);
			this.authService.ApiApplicationSettings();
		});
	}
}

export class SettingTreeElement {
	groupId: number;
	parentGroupId: number;
	settingId: number;
	listId: number;
	name: string;
	value: string;
	description: string;
	isGroup: boolean;
	listValues: any[];

	constructor(groupId: number, parentGroupId: number, settingId: number, listId: number, name: string, value: string, description: string, isGroup: boolean) {
		this.groupId = groupId;
		this.parentGroupId = parentGroupId;
		this.settingId = settingId;
		this.listId = listId;
		this.name = name;
		this.value = value;
		this.description = description;
		this.isGroup = isGroup;
		this.listValues = [];
	}
}
